export default "__VITE_ASSET__f7eb841d__"